import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-layout" }
const _hoisted_2 = { class: "container p24" }
const _hoisted_3 = { class: "flex col g24" }
const _hoisted_4 = { class: "flex justify-between align-center" }
const _hoisted_5 = { class: "flex align-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  style: {"filter":"brightness(50%)"},
  width: "40",
  src: "ico/store2.svg"
}, null, -1)
const _hoisted_7 = {
  class: "text-muted",
  style: {"font-size":"24px"}
}
const _hoisted_8 = { class: "bold" }
const _hoisted_9 = { class: "flex align-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavHeader = _resolveComponent("NavHeader")!
  const _component_ToggleSwitch = _resolveComponent("ToggleSwitch")!
  const _component_SeButton = _resolveComponent("SeButton")!
  const _component_DistributorShop = _resolveComponent("DistributorShop")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_NavHeader, {
      backButton: "false",
      title: _ctx.Lang.getI18N('shop')
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("span", _hoisted_7, [
              _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.state.distributor.name), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_ToggleSwitch, {
              modelValue: _ctx.state.displayUnactives,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.displayUnactives) = $event))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("display-unactives")), 1)
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_SeButton, {
              onPress: _ctx.save,
              ref: "modifyBtn",
              icon: "/ico/save.svg"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("modify")), 1)
              ]),
              _: 1
            }, 8, ["onPress"])
          ])
        ]),
        _createVNode(_component_DistributorShop)
      ])
    ])
  ]))
}